(function ($, window, document, undefined) {
	'use strict';

	var urlParameters = $.deparam(window.location.search.replace(/^\?/, ''));

	$(document).ready(function () {

		window.biotope.HashNavigation();

		// init header
		$('.header').header({
			stickyMinWidth: global.configuration.get('global.bpLarge')
		});

		// init responsive image plugin, note: slider images are initialized on slider ready event
		$('.picture:not(.picture--slider)').responsiveImage({
			autoDpr: true,
			preload: true
		});

		// init offcanvas
		$('.offcanvas').offcanvas({
			mobileMaxWidth: global.configuration.get('global.bpLargeMax')
		});

		// check for backlink and replace href attribute with url stored in localstorage
		var $backlink = $('[data-backlink]');
		var backlinkUrl = localStorage.getItem('backLinkUrl');
		if (backlinkUrl) {
			if ($backlink.length) {
				$backlink.attr('href', backlinkUrl);
			}
			localStorage.removeItem('backLinkUrl');
		}

		// init chosen selectbox
		var $chosen = $('.form__select--chosen');
		if ($chosen.length) {

			// init chosen selects on desktop clients only
			if (!Modernizr.touchevents) {
				$chosen.chosen({
					width: '100%'
				});
			}

			// set pseudo-placeholder to chosen selects for mobile devices
			if (!$chosen.data('chosen')) {
				$chosen.filter('[data-placeholder]').each(function () {

					$(this).find('option:empty')
						.prop({
							disabled: true,
							selected: ($(this).find('option:selected').val() === '')
						})
						.text($(this).data('placeholder'))
						.addClass('form__option--placeholder');
				});
			} else {
				// chosen was loaded, so remove custom select class
				$chosen.closest('.form__select--custom').removeClass('form__select--custom');
			}
		}

		// init layer
		if ($.isFunction($.fn.layer)) {
			$('.layer').layer();
		}

		if(document.getElementsByClassName('header').length) {
			window.biotope.LanguageFlyout(document.getElementsByClassName('header')[0]);
		}

		// Load navigation JSON for mobile AND flyout navigation
		$.getJSON(global.configuration.get('global.navigationJsonUrl'))
			.done(function (json) {

				// init mobile navigation
				$('.offcanvas__area--left').mobileNavigation({
					navigationJson: json
				});

				// init flyout navigation
				$('.header').flyout({
					navigationJson: json
				});

			})
			.fail(function () {
				$('.offcanvas__area--left').html($('<div class="mobileNavigation__error">' + global.configuration.get('i18n.mobileNavigationError') + '</div>'));
			});

		// init multicolumns
		$('.multiColumn').multiColumnList();

		(function () {
			//callback function that parses ajax data (country-contacts.json) and returns an array of marker data objects
			var optimizeAjaxData = function (data) {
				var markers = [];

				$.each(data, function (index, country) {
					$.each(country.contacts, function (key, contact) {
						markers.push(optimizeMarkerData(contact));
					});
				});

				return markers;
			};

			var optimizeMarkerData = function (object) {
				if (object.name) {
					object.headline = object.name;
					delete object.name;
				}

				// add google maps link
				var search = [object.headline, object.address1, object.zip, object.city];
				if (object.address2) {
					search.push(object.address2);
				}
				if (object.address3) {
					search.push(object.address3);
				}

				// temporary disabled
				//object.mapsLink = global.configuration.get('global.googleMapsUrl') + encodeURIComponent(search.join(' ')) + '/@' + object.lat + ',' + object.lng;

				return object;
			};

			//init single marker map
			$('.stoMap--singleMarkerMap').stoMap({
				markerImage: global.configuration.get('staticResourcesBase') + global.configuration.get('global.markerImage')
			});

			//init map with data-ajax attribute
			$('.stoMap--ajax').stoMap({
				markerImage: global.configuration.get('staticResourcesBase') + global.configuration.get('global.markerImage'),
				optimizeAjaxData: optimizeAjaxData
			});

			//init Sto in your Country
			$('.stoCountry').stoCountry({
				optimizeAjaxData: optimizeAjaxData,
				optimizeMarkerData: optimizeMarkerData
			});
		})();

		// init read more elements
		$('.readmore').readmore();

		// init show more elements
		$('.showMore').showMore();

		// init slider
		if ($.isFunction($.fn.slider)) {
			$('.slider').slider();
		}

		// init gallery
		$('.gallery').gallery();

		// init objectFit polyfill on megaStage images
		$('.megaStage__image img').objectFit();

		// init objectFit polyfill on megaPicture images
		$('.megaPicture__image img').objectFit();


		// init objectFit polyfill on system teasers
		$('.teaserSystemFinder--fullwidth').teaserSystemFinder();

		// reinit polyfill if source of responsive image has changed
		$('.megaStage__image .picture').on('new.source.responsiveImage', function () {
			$(this).find('img').objectFit();
		});

		// reinit polyfill if source of responsive image (mega picture) has changed
		$('.megaPicture__image .picture').on('new.source.responsiveImage', function () {
			$(this).find('img').objectFit();
		});

		// check if session storage contains former scroll position only on non-layer pages
		if (sessionStorage.getItem('scroll') && $('.layer').length === 0) {
			var scroll = $.parseJSON(sessionStorage.getItem('scroll'));
			if (scroll !== null && scroll.location === window.location.pathname) {
				// scroll to stored position
				$(window).scrollTop(scroll.position);
			}

			// reset sessionStorage scroll
			sessionStorage.removeItem('scroll');
		}

		// init accordions in default layout
		$('.layout--default .accordion').accordion({
			headerResponsiveHeights: [{minWidth: 992, height: 72}]
		});

		// init accordions in layer framework
		$('.layer .accordion').accordion({
			headerResponsiveHeights: [{minWidth: 0, height: 50}]
		});

		// init responsive tables
		$('table.responsive').responsiveTables();

		// init filtered search for reference list
		if( $.isFunction( $.fn.referenceList ) ) {
			var searchUrl = ($('.referenceList').hasClass('.referenceList--gallery')) ? 'global.gallerySearchUrl' : 'global.referenceSearchUrl';
			$('.referenceList').referenceList({
				searchUrl: global.configuration.get(searchUrl),
				offcanvasFilterMaxWidth: global.configuration.get('global.bpLargeMax'),
				largeResultItemsMinWidth: global.configuration.get('global.bpLarge'),
				hideMapMaxWidth: global.configuration.get('global.bpMediumMax'),
				rows: global.configuration.get('global.referenceSearchRows')
			});
		}

		// init filtered search for system finder list
		if ($.isFunction($.fn.systemFinderList)) {
			$('.systemFinderList').systemFinderList({
				searchUrl: global.configuration.get('global.systemFinderSearchUrl'),
				offcanvasFilterMaxWidth: global.configuration.get('global.bpLargeMax'),
				rows: global.configuration.get('global.systemFinderSearchRows')
			});
		}

		// init download teaser
		$('.downloadTeaser').downloadTeaser();

		// init news and events list
		$('.newsList').newsList();

		// init contact form
		$('.contact').contact();

		//init videos outside stage
		$('.video:not(html)').each(function () {
			if ($(this).closest('.megaStage').length === 0) {
				$(this).video({});
			}
			if( $(this).closest('.megaPicture').length === 0 ) {
				$(this).video({});
			}
		});

		//init stage videos
		if ($.isFunction($.fn.stageVideo)) {
			$('.megaStage--video').stageVideo();
			$('.megaPicture--video').stageVideo({selector: 'megaPicture'});
		}

		if ($.isFunction($.fn.stageYoutube)) {
			$('.megaStage--youtube').stageYoutube();
			$('.megaPicture--youtube').stageYoutube({selector: 'megaPicture'});
		}

		// DEV-note: make sure to initialize all components before initializing scrolling

		// scrolling
		if ($.isNumeric(urlParameters.scroll)) {
			$('html, body').animate({
				scrollTop: urlParameters.scroll
			}, 400);
		}

		// scroll top
		$('[data-scroll-to]').on('click', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: 0
			}, 400);
		});

		// listen to footer country change event
		$('.footer .form__select--chosen, [data-option-link]').on('change', function (event, params) {
			var redirect = '';
			if (params && typeof(params.selected) !== 'undefined') {
				redirect = params.selected;
			} else if ($(this).val() !== '') {
				redirect = $(this).val();
			}

			if (redirect !== '') {
				// reset selected option
				$(this).val('').trigger('chosen:updated');
				location.href = redirect;
			}
		});

		// init browserwarning
		$(this).browserWarning({
			targetElement: '.header__sticky',
			insertWith: 'prepend',
			onWarningShown: function() {
				$('.header').data('plugin_header').resetStickyMargin();
			}
		});

		if( $.isFunction( $.fn.overview) ) {
			$('.overview--advanced').overview();
		}

		// dispatch event when main is initalized

		// workaround for IE11
		let event;
		if (typeof(Event) === 'function') {
			event = new Event('mainInitialized');
		} else {
			event = document.createEvent('Event');
			event.initEvent('mainInitialized', true, true);
		}
		window.dispatchEvent(event);
	});

	// $(window).load(function() {});

})(jQuery, window, document);
